export interface SalesDespatchNote {
  id: string;
  despatchNoteNo: number;
  despatchDate: Date;
  salesOrderNo: string;
  CustomerOrderRef: string;
  createdBy: string;
  customerKey: string;
  customerName: string;
  deliveryAddress: string;
  notes: string;
  shipperSupplier: string;
  trackingNo: string;
  grossQty: number;
  nettQty: number;
  noOfItems: number;
  value: number;
  salesDespatchNoteStatus: string;
  colour: string;
  selected: boolean;
}
